module.exports = __webpack_public_path__ + "static/cookies-policy-f246685f1a6988eeabf0a04fc15d5a1a.pdf";